import { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getCocallerAppSettingsApi } from '../../api/Dhwani/cocallerAppSettings.api';
import { GET_COCALLER_APP_SETTINGS } from '../../constants/ActionTypes';
import { HTTP_STATUS_CODES } from '../../constants/HttpConstants';
import { errorHandler } from '../utils.saga';

/**
 * Get Cocaller App Settings Saga
 * @returns {void}
 */
function* getCocallerAppSettings() {
  try {
    const response: AxiosResponse = yield call(getCocallerAppSettingsApi);

    if (
      response &&
      response.status === HTTP_STATUS_CODES.OK &&
      response.data?.data
    ) {
      yield put({
        type: `${GET_COCALLER_APP_SETTINGS}_SUCCESS`,
        payload: response.data.data,
      });
    } else {
      yield put({
        type: `${GET_COCALLER_APP_SETTINGS}_FAILURE`,
        payload: response.data?.message || 'Failed to get app settings',
      });
    }
  } catch (err) {
    const message: string | null = yield call(errorHandler, err);
    yield put({
      type: `${GET_COCALLER_APP_SETTINGS}_FAILURE`,
      payload: message,
    });
  }
}

/**
 * Cocaller App Settings Saga
 * @returns {void}
 */
export default function* cocallerAppSettingsSaga() {
  yield takeLatest(GET_COCALLER_APP_SETTINGS, getCocallerAppSettings);
}
